import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { withTheme } from "styled-components";

import { SeoRenderer } from "../../../common/helpers/seo";

import { get } from "../../actions/general";

import loadingComponent from "./loadable";

export default {
    component: connect(null, { get })(injectIntl(withTheme(loadingComponent))),
    renderSeo: (store: any, allMessage: { homework: string }, lang: string) => {
        SeoRenderer({ title: allMessage["homework"], allMessage, lang });
    },
};
